<template>
	<div class="fileClass">
		<div style="height: 40px">
			<span v-for="(itemName, index1) in currentName" :key="index1" class="titleSpanClass" @click="changeTitle(itemName)"><span v-if="index1 != 0"> / </span>{{ itemName.name }} </span>
			<span v-if="dataInfoTitleName != ''"> / {{ dataInfoTitleName }}</span>

			<!-- <el-breadcrumb separator="/">
				<el-breadcrumb-item v-for="(itemName, index1) in currentName" :key="index1">
					<div @click="changeTitle(itemName)">{{ itemName.name }} /</div>
				</el-breadcrumb-item>
			</el-breadcrumb> -->
		</div>
		<div v-if="dataInfoFlag">
			<el-table :data="fileArr" v-if="!fileFlag" v-loading="loading" stripe height="400">
				<el-table-column label="文件名称">
					<template slot-scope="scope"
						><div style="cursor: pointer">
							<i class="el-icon-folder-opened"></i> <a @click="fileChage(scope.row)">{{ scope.row.name }}</a>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<el-table :data="fileArr" v-else stripe v-loading="loading" height="400">
				<el-table-column label="文件名称" width="700">
					<template slot-scope="scope"><i class="el-icon-document"></i>{{ scope.row.name }} </template>
				</el-table-column>
				<el-table-column label="文件大小">
					<template slot-scope="scope"> {{ formatBytes(scope.row.dataSize) }} </template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope"
						><el-button type="text" @click="infoChange(scope.row)">查看详情</el-button>
						<el-button type="text" @click="getAnnexZip(scope.row)">下载</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagediv" v-if="fileArr.length > 0 && fileFlag">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[10, 20, 30, 50]"
					:page-size="100"
					layout="total, sizes, prev, pager, next, jumper"
					:total="listTotal"
				>
				</el-pagination>
			</div>
		</div>
		<!-- <el-dialog title="数据详情" :visible.sync="dialogVisible" width="40%"> -->
		<div v-else style="display: flex; margin: auto; justify-content: center">
			<div v-for="(item, i) in infoList" :key="i" class="dataItemGird">
				<div v-if="item.image" style="width: 50%; margin: auto; background: #d7deed">
					<div class="item_img">
						<img class="item_img" @click="imgClick(item.image)" :src="imgServeUrl + item.image" alt="" />
					</div>
					<div class="item_label">
						<div class="item_title">
							<div class="_title" :title="item.name">{{ item.name }}</div>
						</div>

						<div class="item_Cz">
							<div class="item_CzSl">
								<div class="CzSl_list">
									<div class="CzSl_listLabel">接收站：</div>
									<div class="CzSl_listtext">{{ item.receivingStation }}</div>
								</div>
								<div class="CzSl_list">
									<div class="CzSl_listLabel">开始时间：</div>
									<div class="CzSl_listtext">{{ item.startTime }}</div>
								</div>
								<div class="CzSl_list">
									<div class="CzSl_listLabel">结束时间：</div>
									<div class="CzSl_listtext">{{ item.endTime }}</div>
								</div>
								<div class="CzSl_list">
									<div class="CzSl_listLabel">探测任务：</div>
									<div class="CzSl_listtext">{{ item.detectionTask }}</div>
								</div>
								<div class="CzSl_list">
									<div class="CzSl_listLabel">有效载荷：</div>
									<div class="CzSl_listtext">{{ item.loadName }}</div>
								</div>
								<div class="CzSl_list">
									<div class="CzSl_listLabel">数据级别：</div>
									<div class="CzSl_listtext">{{ item.dataLevelName }}</div>
								</div>
								<div class="CzSl_list">
									<div class="CzSl_listLabel">大小：</div>
									<div class="CzSl_listtext">{{ formatBytes(item.dataSize) }}</div>
								</div>

								<div class="CzSl_list">
									<div class="CzSl_listLabel">数据版本：</div>
									<div class="CzSl_listtext">{{ item.dataVersion }}</div>
								</div>
							</div>
						</div>
						<div class="item_title" style="justify-content: center; display: flex; margin-top: 10px">
							<div class="item_CzBtn1" @click="getAnnexZip(item)">立即下载</div>
							<div class="item_CzBtn2" @click="dataMark(item)">{{ item.bookmark ? '取消收藏' : '加入收藏夹' }}</div>
						</div>
					</div>
				</div>
				<div v-else style="display: flex">
					<img style="width: 20rem; height: 12rem" v-if="!item.image" :src="defualtImg" alt="" />
					<div class="item_label">
						<div class="item_title">
							<div class="_title" style="height: auto; padding: 10px 0px; word-break: break-all; line-height: 26px; width: 95%" :title="item.name">{{ item.name }}</div>
						</div>
						<div class="item_Cz">
							<div class="item_CzSl">
								<div class="CzSl_list">
									<div class="CzSl_listLabel">接收站：</div>
									<div class="CzSl_listtext">{{ item.receivingStation }}</div>
								</div>
								<div class="CzSl_list">
									<div class="CzSl_listLabel">开始时间：</div>
									<div class="CzSl_listtext">{{ item.startTime }}</div>
								</div>
								<div class="CzSl_list">
									<div class="CzSl_listLabel">结束时间：</div>
									<div class="CzSl_listtext">{{ item.endTime }}</div>
								</div>
								<div class="CzSl_list">
									<div class="CzSl_listLabel">探测任务：</div>
									<div class="CzSl_listtext">{{ item.detectionTask }}</div>
								</div>
								<div class="CzSl_list">
									<div class="CzSl_listLabel">有效载荷：</div>
									<div class="CzSl_listtext">{{ item.loadName }}</div>
								</div>
								<div class="CzSl_list">
									<div class="CzSl_listLabel">数据级别：</div>
									<div class="CzSl_listtext">{{ item.dataLevelName }}</div>
								</div>
								<div class="CzSl_list">
									<div class="CzSl_listLabel">大小：</div>
									<div class="CzSl_listtext">{{ formatBytes(item.dataSize) }}</div>
								</div>

								<div class="CzSl_list">
									<div class="CzSl_listLabel">数据版本</div>
									<div class="CzSl_listtext">{{ item.dataVersion }}</div>
								</div>
							</div>
						</div>
						<div class="item_title" style="justify-content: center; display: flex; margin-top: 10px">
							<div class="item_CzBtn1" @click="getAnnexZip(item)">立即下载</div>
							<div class="item_CzBtn2" @click="dataMark(item)">{{ item.bookmark ? '取消收藏' : '加入收藏夹' }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span> -->
		<!-- </el-dialog> -->
	</div>
</template>

<script>
import axios from 'axios'
import cookie from '@/utils/cookie.js'

export default {
	data() {
		return {
			dataInfoTitleName: '',
			dataInfoFlag: true,
			defualtImg: require('./../../assets/mars.png'),
			imgServeUrl: window.dataManage.imgDev,
			loading: false,
			infoList: [],
			dialogVisible: false,
			currentPage: 1,
			listTotal: 0,
			pageSize: 1, //页
			pageNum: 10, //条
			fileFlag: false,
			fileArr: [],
			currentName: [{ name: '科学数据' }]
		}
	},
	mounted() {
		this.getdata()
	},
	methods: {
		imgClick(url) {
			window.open(this.imgServeUrl + url, '_blank')
		},
		formatBytes(bytes, decimals = 2) {
			if (bytes === 0) return '0 Bytes'
			const k = 1024
			const dm = decimals < 0 ? 0 : decimals
			const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
			const i = Math.floor(Math.log(bytes) / Math.log(k))
			return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
		},
		async getAnnexZip(obj, flag) {
			let paramData = ''
			if (flag) {
				paramData = obj
			} else {
				paramData = obj.dataInfoId
			}
			const authorizationVal = this.$cookie.get('PIE_MALL_Token')
			// 基础 POST 下载
			axios({
				method: 'get',
				url: `${window.dataManage.devPrefix}/client/science/dataInfo/getAnnexZip/${paramData}`,
				// data: paramData,
				headers: {
					Authorization: `Bearer ${authorizationVal}`
				}
				// responseType: 'blob' // 重要：指定响应类型为 blob
			})
				.then((response) => {
					this.$message.success('下载成功！')
					window.open(response.data.data, '_blank')
					// 创建 blob 对象
					// const blob = new Blob([response.data], { type: 'text/plain' })
					// console.log(response.data)
					// // 创建下载链接
					// const url = window.URL.createObjectURL(blob)
					// const link = document.createElement('a')
					// link.href = url
					// link.download = obj.name // 设置下载文件名
					// document.body.appendChild(link)
					// link.click()
					// // 清理
					// document.body.removeChild(link)
					// window.URL.revokeObjectURL(url)
				})
				.catch((error) => {
					console.error('下载失败:', error)
				})
		},
		async getAnnexZip2(obj, flag) {
			// const userToken = cookie.get('PIE_MALL_Token')
			// if (!userToken) {
			// 	this.$message.warning('请登录用户！')
			// 	return
			// }
			let res = ''
			if (flag) {
				res = await this.$http.get(this.$const.Platformconsulting.getAnnexZipURl + obj)
			} else {
				res = await this.$http.get(this.$const.Platformconsulting.getAnnexZipURl + obj.dataInfoId)
				this.$message.success('下载成功！')
			}
			if (res.code === 200) {
				let res1 = await this.$http.download(this.$const.Platformconsulting.downloadURl, { fileName: res.data, delete: true })
			}
		},
		async dataMark(obj) {
			const userToken = cookie.get('PIE_MALL_Token')
			if (!userToken) {
				this.$message.warning('请登录用户！')
				return
			}
			if (obj.bookmark) {
				try {
					let res = await this.$http.delete(this.$const.Platformconsulting.batchSciencebookmarkdelURL, [obj.dataInfoId])
					if (res.code === 200) {
						obj.bookmark = !obj.bookmark
						this.$message.success('取消收藏成功！')
					}
				} catch (e) {
					this.$message.error('操作失败')
				}
			} else {
				try {
					let res = await this.$http.post(this.$const.Platformconsulting.batchSciencebookmarkaddURL, [obj.dataInfoId])
					this.$message.success('收藏成功！')
					if (res.code === 200) {
						obj.bookmark = !obj.bookmark
					}
				} catch (e) {
					this.$message.error('操作失败')
				}
			}
		},
		infoChange(item) {
			this.dataInfoTitleName = item.name
			this.infoList = []
			this.infoList.push(item)
			// this.dialogVisible = true
			this.dataInfoFlag = false
		},
		handleSizeChange(val) {
			this.pageNum = val
			this.getSearchList()
		},
		handleCurrentChange(val) {
			this.pageSize = val
			this.getSearchList()
		},
		changeTitle(item) {
			this.dataInfoTitleName = ''
			this.fileFlag = false
			this.dataInfoFlag = true

			if (item.name == '科学数据') {
				this.fileArr = []
				this.currentName = [{ name: '科学数据' }]
				this.getdata()
			} else {
				let indexFind = -1
				this.currentName.forEach((element, index) => {
					if (element.name == item.name) {
						indexFind = index
					}
				})
				if (item.children) {
					this.fileArr = item.children
				}
				if (indexFind != -1 && this.currentName.length - 1 != indexFind) {
					this.currentName.splice(indexFind + 1)
				} else {
					this.loading = true
					this.fileFlag = true
					this.getSearchList()
				}
			}
		},
		async getdata() {
			this.fileFlag = true
			this.fileArr = []
			let res = await this.$http.get(this.$const.Platformconsulting.scienceCategoryURl)
			if (res.code === 200) {
				// const resData = res.data[1]
				// children.reverse()
				this.fileFlag = false
				this.fileArr.push(res.data[0])
			}
		},
		// 检索数据

		async getSearchList() {
			this.fileArr = []
			var parms = {
				pageNum: this.pageSize,
				pageSize: this.pageNum,
				category: this.currentName.length > 1 ? this.currentName[1].id : '', // 火星 id
				task: this.currentName.length > 2 ? this.currentName[2].id : '', //任务id 天问一号
				dataCatalogueId: '', //数据任务目录id
				load: this.currentName.length > 3 ? this.currentName[3].id : '', //载荷 id
				dataLevel: this.currentName.length > 4 ? this.currentName[4].id : '' //数据级别 id
			}
			let res = await this.$http.get(this.$const.Platformconsulting.dataInfoListURL, parms)
			this.loading = false
			if (res.code === 200) {
				this.listTotal = res.total
				this.fileArr = res.rows
			}
		},
		fileChage(item) {
			this.fileFlag = false
			if (item.children && item.children.length == 0) {
				this.fileFlag = true
			}
			this.currentName.push(item)
			if (item && item.children.length > 0) {
				this.fileArr = item.children
			} else {
				this.loading = true
				this.getSearchList()
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.folderClass {
	height: 40px;
	line-height: 40px;
	font-size: 16px;
}
.titleSpanClass:hover {
	color: #3a8ee6;
}
.titleSpanClass {
	display: line-block;
	cursor: pointer;
	border-bottom: 1px solid #c0c4cc;
}
.dataItemGird {
	display: flex;
	// width: 50%;
	flex-direction: column;
	// flex-wrap: wrap;
	min-height: 200px;
	margin-bottom: 15px;
	// width: 33%;
	margin-right: 15px;
	// background: #d7deed;
	.item_img {
		// width: 100%;
		// height: 300px;
		width: 100%;
		height: 25rem;
		background: #000;
		cursor: pointer;
	}
	.item_label {
		margin-left: 15px;
		width: 100%;
	}
	.item_title {
		display: flex;
		._title {
			// overflow: hidden;
			font-family: MicrosoftYaHeiUISemibold;
			font-size: 18px;
			color: #000000;
			text-align: left;
			// height: 40px;
			line-height: 30px;
			// width: 95%;
			font-weight: 700;
			cursor: pointer;
			width: 95%;
			word-break: break-all;
		}
		._btn {
			display: flex;
			flex: 1;
			justify-content: flex-end;
			.btnlist {
				background: #daa77f7b;
				margin-right: 15px;
				border-radius: 2px;
				font-family: MicrosoftYaHeiUISemibold;
				font-size: 14px;
				// color: #cc7f3f;
				color: #15418c;
				height: 30px;
				line-height: 30px;
				text-align: center;
				font-style: normal;
				padding: 0px 8px;
			}
		}
		.item_CzBtn1 {
			margin-right: 15px;
			width: 88px;
			height: 40px;
			// background-image: url('../../assets/imgs/RemoteSensingMall/card1.png');
			background-repeat: no-repeat;
			// background-size: cover;
			background-size: 100% 100%;

			text-align: center;
			line-height: 40px;
			color: #fff;
			cursor: pointer;
			font-size: 14px;
			margin-bottom: 15px;

			background: #15418c;
		}
		.item_CzBtn2 {
			margin-right: 15px;
			width: 88px;
			height: 40px;
			// background-image: url('../../assets/imgs/RemoteSensingMall/card2.png');
			background-repeat: no-repeat;
			background-size: 100% 100%;
			text-align: center;
			line-height: 40px;
			// color: #cc7f3f;
			color: #15418c;
			cursor: pointer;
			font-size: 14px;
			margin-bottom: 15px;

			background: radial-gradient(208% 143% at 50% 0, rgba(21, 65, 140, 0.3) 0, rgba(21, 65, 140, 0) 100%);
			color: #15418c;
		}
	}
	.item_Cz {
		// display: flex;
		// padding: 15px 0;
		.item_CzSl {
			flex: 1;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			align-items: baseline;
			margin-top: 10px;
			.CzSl_list {
				display: flex;
				// flex-wrap: wrap;
				// flex-wrap: nowrap;
				width: 24%;
				height: 30px;
				.CzSl_listLabel {
					width: 74px;
					height: 30px;

					font-family: MicrosoftYaHeiUI;
					font-size: 14px;
					color: #666666;
					text-align: left;
					font-style: normal;
				}

				.CzSl_listtext {
					font-family: MicrosoftYaHeiUI;
					font-size: 14px;
					// color: #cc7f3f;
					color: #15418c;
					// text-align: left;
					text-align: center;
					font-style: normal;
				}
				text-align: center;
			}
		}
		.item_CzBtn {
			width: 88px;
			height: 67px;
			// background-image: url('../../assets/imgs/RemoteSensingMall/card1.png');
			background-repeat: no-repeat;
			background-size: cover;
			text-align: center;
			line-height: 67px;
			color: #fff;
			cursor: pointer;

			background: #15418c;
		}
	}
}
.el-table--enable-row-transition .el-table__body td.el-table__cell {
	cursor: pointer;
}
</style>